import isEmail from 'validator/lib/isEmail'
import isEmpty from 'validator/lib/isEmpty'
// import isAlphanumeric from 'validator/lib/isAlphanumeric'
// import matches from 'validator/lib/matches'
import { Ref } from '@vue/composition-api'

export const checkEmail = (string: string | null) => {
    if (!checkRequire(string)) {
        return true
    }

    return isEmail(string || '')
}

export const checkRequire = (value: string | any[] | null) => {
    if (Array.isArray(value)) {
        return value.length > 0
    } else {
        return !isEmpty(value || '')
    }
}

// export const checkAlphanumeric = (string: string | null) => {
//     return isAlphanumeric(string || '')
// }

// export const checkHiragana = (string: string | null) => {
//     return matches(
//         string || '',
//         /^[\u{3000}-\u{301C}\u{3041}-\u{3093}\u{309B}-\u{309E}]+$/mu
//     )
// }

// export const checkKatakana = (string: string | null) => {
//     return matches(
//         string || '',
//         /^[\u{3000}-\u{301C}\u{30A1}-\u{30F6}\u{30FB}-\u{30FE}]+$/mu
//     )
// }

// export const checkPassCode = (string: string | null) => {
//     return matches(
//         string || '',
//         /^(?=.*?[a-z])(?=.*?\d)(?=.*?[!-/:-@[-`{-~])[!-~]+$/i
//     )
// }

// export const checkMinLength = (string: string | null, length: number) => {
//     return (string || '').length >= length
// }

// export const checkMaxLength = (string: string | null, length: number) => {
//     return (string || '').length <= length
// }

// export const checkEqual = (string: string | null, target: string | null) => {
//     return string === target
// }

export type useValidateOptions = {
    required?: Ref<boolean>
    email?: Ref<boolean>
}
export type FlagType = -1 | 0 | 1
export type ResultType = {
    required?: boolean
    email?: boolean
}

const validateArray = (
    values: string[],
    options: useValidateOptions,
    callback: (result: ResultType, flag: FlagType, inputted: boolean) => void
) => {
    const result: ResultType = {}
    let flag: FlagType = 1

    let inputted = false
    if (values.length > 0) {
        inputted = true
    }

    const isRequired = options.required?.value || false
    if (isRequired) {
        result.required = true
        if (values.length <= 0) {
            result.required = false
            flag = -1
        }
    }

    return callback(result, flag, inputted)
}

export const useValidate = (
    options: useValidateOptions,
    callback: (result: ResultType, flag: FlagType, inputted?: boolean) => void
) => {
    return (e: FocusEvent | Event | string | string[]) => {
        if (Array.isArray(e)) {
            return validateArray(e, options, callback)
        }

        const result: ResultType = {}
        let flag: FlagType = 0
        let inputted = false

        // Check input field type
        if (typeof e !== 'string' && !Array.isArray(e)) {
            if (!e.target) {
                return callback(result, flag, inputted)
            }
            const target = e.target as HTMLInputElement | HTMLSelectElement

            if (target.type.toLowerCase() === 'checkbox') {
                setTimeout(() => {
                    const values: string[] = []
                    const nodeList = document.querySelectorAll(
                        `input[name="${target.name}"]`
                    )
                    const nodes = Array.prototype.slice.call(
                        nodeList,
                        0
                    ) as HTMLInputElement[]

                    nodes.forEach(function (element) {
                        if (element.checked) {
                            values.push(element.value)
                        }
                    })

                    return validateArray(values, options, callback)
                }, 0)
            }
        }

        const string = (() => {
            if (typeof e === 'string') {
                return e
            } else {
                if (!e.target) {
                    return null
                }
                const target = e.target as HTMLInputElement | HTMLSelectElement
                return target.value
            }
        })()
        flag = 1

        if (string === null) {
            return callback(result, flag, inputted)
        }

        if (checkRequire(string)) {
            inputted = true
        }

        const isRequired = options.required?.value || false
        if (isRequired) {
            result.required = true
            if (!checkRequire(string)) {
                result.required = false
                flag = -1
            }
        }

        const isEmail = options.email?.value || false
        if (isEmail) {
            result.email = true
            if (!checkEmail(string)) {
                result.email = false
                flag = -1
            }
        }

        return callback(result, flag, inputted)
    }
}
